export async function getImageClipboardItem(options: {
  imageUrl: string; // The string body of the panel (expected to be an image URL or path)
}): Promise<ClipboardItem | null> {
  const { imageUrl } = options;
  if (!imageUrl) return null;

  // Check if imageUrl is a URL and fetch the image directly
  if (/^(https?:\/\/|\/)/.test(imageUrl)) {
    try {
      const response = await fetch(imageUrl);
      const blob = await response.blob();

      if (blob.type.startsWith('image/')) {
        const representations: Record<string, Blob> = {
          [blob.type]: blob,
        };

        return new ClipboardItem(representations);
      }
    } catch {
      // NOTE: Fetch failed, fall back to text only
    }
  }

  // Fallback to text-only clipboard item
  const representations: Record<string, Blob> = {
    'text/plain': new Blob([imageUrl], { type: 'text/plain' }),
  };

  return new ClipboardItem(representations);
}
